angular.module('AppCtrl.ContactDetails.urls', ['jv.Common.Jobvite.Urls']).
	factory('contactDetailsConstant', ['$jobviteUrls', function($jobviteUrls) {
		return {
			Urls: {
				'shareContact': jvUrls.source + '/action/person/contactDetailsPage',
				'addToRequisition': jvUrls.source + '/action/person/contactList',
				'getReqFilters' :jvUrls.jhire+'/action/requisitions/filters',
				'saveTags' : jvUrls.source + '/action/person/contactDetailsPage',
				'settings' : jvUrls.admin + '/action/admin/configuration?',
				'getMessageTemplates': jvUrls.source + '/action/person/contactDetailsPage',
				'doSeekConsent': jvUrls.source + '/action/person/contactDetailsPage'
			},
			Const: {
				getApplications: "div[TYPE='DETAIL'][KEY='APPLICATIONS']"
			}
		}
	}]);

angular.module('AppCtrl.ContactDetails.service',['AppCtrl.ContactDetails.urls', 'AppCtrl.web.service','jv.Common.TemplateLoader','jv.Common.Modal', 'jv.Common.Directives.Formtemplate', 'jv.Common.Directives.MessageTemplate']).
	service('contactDetailsService', function(contactDetailsConstant, makeAjaxCall, $http) {
		var contactDetailsService = {};

		contactDetailsService.getShareContact = function( args, callback){
			callback = (callback || angular.noop);
			const _contactDetailsObject = args || { };
			_contactDetailsObject['url'] = contactDetailsConstant.Urls.shareContact;
			_contactDetailsObject['ajaxtype'] = 'shareContact';
			_contactDetailsObject['requestType'] = 'POST';
			var _deleteContact = makeAjaxCall( _contactDetailsObject );
			_deleteContact.then(function( results ){
				callback(results.data);
			});	
		}

		contactDetailsService.getEmailTemplatesForSeekConsent = function( args, callback){
            callback = (callback || angular.noop);
            const _contactDetailsObject = args || { };
            _contactDetailsObject['url'] = contactDetailsConstant.Urls.getMessageTemplates;
            _contactDetailsObject['ajaxtype'] = 'getMessageTemplates';
            _contactDetailsObject['requestType'] = 'POST';
            var _response = makeAjaxCall( _contactDetailsObject );
            _response.then(function( results ){
                callback(results.data);
            });
        }

        contactDetailsService.doSeekConsent = function( args, callback){
            callback = (callback || angular.noop);
            const _contactDetailsObject = args || { };
            _contactDetailsObject['url'] = contactDetailsConstant.Urls.doSeekConsent;
            _contactDetailsObject['ajaxtype'] = 'doSeekConsent';
            _contactDetailsObject['requestType'] = 'POST';
            var _response = makeAjaxCall( _contactDetailsObject );
            _response.then(function( results ){
                callback(results);
            });
        }
		
		contactDetailsService.addToRequisition = function( args, callback){
			var args = {
					url: contactDetailsConstant.Urls.addToRequisition,
					jobIds: args.ids,
					ajaxtype: 'addContactsToReqs',
					action: 'addContactsToReqs',
					requestType: 'POST',
					ids:args.eids
			};
			var _performContactAction = makeAjaxCall(args);
			_performContactAction.then(function( results ){
				callback(results);
			});
		}
		
		contactDetailsService.getReqsFilters = function(callback) {
			callback = (callback || angular.noop);
			var _reqsFilter = {};
			_reqsFilter['url'] =  contactDetailsConstant.Urls.getReqFilters;
			_reqsFilter['ajaxtype'] = 'getReqsFilters';
			var _getReqsFilters = makeAjaxCall( _reqsFilter );
			_getReqsFilters.then(function( results ){
				callback(results.data);
			});
		};
		
		contactDetailsService.getApplications = function(page) {
			var args = {
					action: 'getApplications',
					ids: $('#contactIds').val(),
					page: !!page? page: 0,
					url: contactDetailsConstant.Urls.shareContact,
					ajaxtype: 'getApplications'
			};
			var _performContactAction = makeAjaxCall( args );
			_performContactAction.then(function( results ){
				 $(contactDetailsConstant.Const.getApplications).html(results.data).removeClass('jv-hide');
			}, function( results ){
				$(contactDetailsConstant.Const.getApplications).html('').addClass('jv-hide');
		   });
		};
		
		contactDetailsService.saveTags = function(args, callback) {
			var args = {
					url: contactDetailsConstant.Urls.saveTags,
					tagNames: args.tagNames,
					ajaxtype: 'doSaveTags',
					action: 'doSaveTags',
					requestType: 'POST',
					ids: args.ids
			};
			var _saveTags = makeAjaxCall(args);
			_saveTags.then(function( results ){
				callback(results);
			});
		};
				
		var tagSearchUrl = jvUrls.source + '/action/person/contactList';
		
		contactDetailsService.tagSelect = function(tagsLocked){
	        var url = tagSearchUrl;
	        var pageSize = 50;
	        var config = {
	        	minimumInputLength: 1,
	        	formatInputTooShort: function () { return ''; },
	            ajax : {
	                url : url,
	                
	                quietMillis: 100,
	                data : function (term, page) {
						pageSize = 50;
						const result = {
							prefix: term,
							action: 'getTagsWithPrefix'
						};

	                	// Query parameters will be
						// ?prefix=<term>&action=getTagsWithPrefix
	                	return result;
	                },
	                results: function (data, page) { // parse the results into
														// the format expected by
														// Select2.
	                    var more = false;
	                    var results = [];
	                    
	                    // make the id field identical to the name field so that it matches any manually created entries
                        angular.forEach(data.data, function(value, index){
                            value.id = value.name;
                            results[index]= value;
                        });
	                    
	                    return {
	                        results: results,
	                        more: more
	                    };
	                }
	            },
	            formatResult: function (data, container, query, escapeMarkup) {
	              data.name = escapeMarkup(data.name);
	              return data.name;
	            },
	            formatSelection: function (data) {
	            	return data.name;
	            },
	            // Allow manually entered text in drop down if tags are not locked
	            createSearchChoice: function(term) { 
	            	var normalized;
	            	if (!tagsLocked) {
	            		normalized = term.toLowerCase().trim();
	            		if (normalized) {
		 	            	return {
			            		id: normalized,
			            		name: normalized
			            	};
	            		}
	            	}
	            },
	            
	        };
	        return config;
	    };
		
		return contactDetailsService;
});